<div class="c-sona-general-layout__header tw-bg-white">
    <div [class]="headerContainerClass()">
        <ng-content select="[sonaGeneralLayoutHeader]"></ng-content>
    </div>
</div>
<div class="c-sona-general-layout__content">
    <div [class]="contentContainerClass()">
        <ng-content select="[sonaGeneralLayoutContent]"></ng-content>
    </div>
</div>
